/**
 * 国际化配置 => 简体中文
 */
export default {
    // 首页
    home: {
        title: '首页',
        backHome: '返回首页',
        personalCenter:'个人中心',
    },
    personal: {
        common: '通用',
        basicData: '基本资料',
        setting1: '更换头像',
        setting2: '个人资料',
        setting3: '修改密码',
        setting4: '修改手机',
        setting5: '更换Logo',
        setting6: '基本信息',
        setting7: '导出列表',
        setting8: '导入列表',
        setting9: '我的消息',
        setting10: '个性设置',
    },
    // 顶部导航栏
    navbar: {
        logOut: '退出登录',
        home: '首页',
        screenfull: '全屏',
        theme: '换肤',
        // 布局大小
        size: {
            title: '布局大小',
            default: '默认',
            medium: '中',
            small: '小',
            mini: '迷你',
        },
        i18n: '国际化',
        tenant: '租户',
        uptInfo: '设置'
    },
    // 登录页
    login: {
        title: '物联平台登录',
        logIn: '登录',
        username: '账号',
        password: '密码',
        companyTemplate: '模版',
        templateTotalPrice: '价格',
        qrLogin: '扫码登录',
        pwdLogin: '密码登录',
        openAPPLogin: '打开平台APP',
        forScanQR: '扫一扫登录',
        notAccount: "若没有账号？",
        addUser: '注册账号',
        addCompany: '免费注册公司',
        registUser: '同意条款并注册',
        registSuccess: '注册成功',
        registFailed: '注册失败',
        agreeServiceTerms: '我已阅读并同意',
        serviceTerms: '《平台服务条款》',
        haveAccount: '已有账号？',
        toLoginPage: '快捷登录',
        error1: '二维码已失效，请点击刷新',
        error2: '账号只能为字母和数字的组合',
        error3: '该账号已被封禁，如有疑问请联系管理员！',
        error4: '用户已被锁定，请',
        error5: '秒后重试',
        error6: '账号或密码错误，还可以尝试',
        error7: '次',
        loginNow: '是否现在登录？',
        companyHolder: '请输入公司名称',
        templateHolder: '请选择服务模版'
    },
    //找回密码
    forget: {
        entryAccount: '请填写您需要找回的帐号',
        entryCaptcha: '请填写您收到的验证码',
        entryPassword: '请重置您的密码',
        password: '忘记密码',
        resetSuccess: '恭喜您！密码已重置！',
        retryLogin: '返回登录',
        accountInfo: '账号信息',
        captcha: '验证码',
        validMessage: {
            nExistAccount: '账号不存在',
            unMatchCaptch: '验证码不匹配',
            captchExpire: '验证码已过期',
            unMatchPwd: '密码不匹配'
        }
    },
    // 操作日志
    auditLog: {
        creationDate: '操作时间',
        userAccount: '操作账号',
        ip: 'IP地址',
        host: '操作主机',
        operation: '操作',
        module: '模块',
        message: '信息'
    },
    // lookup
    lookup: {
        // 添加分类
        addClassify: '添加分类',
        // 分类列表
        classifyList: '分类列表',
        // 项列表
        itemList: '项列表',
        classifyCode: '类别编码',
        classifyName: '类别名称',
        classifyDesc: '描述',
        // 添加项
        addItem: '添加项',
        editItem: '编辑项',
        itemCode: '项编码',
        itemName: '项名称',
        attr1: '属性1',
        attr2: '属性2',
        language: '语言',
        itemDesc: '描述',
    },
    //菜单管理
    sitemap: {
        addRootSitemap : '添加主菜单',
        name : '菜单名',
        href : '链接',
        permission : '权限',
        icon : '图标',
        policy : '显示策略',
        userAccounts : '添加可见账号',
        parentLevel : '父级',
        sonShow : '有子菜单时显示',
        everShow :'总是显示',
        tenantShow:"仅租户可见",
        platformShow:"仅平台管理可见",
    },
    //注册表
    registry: {
        addRootProperty :'添加根属性',
        name : '名称',
        displayName : '显示名称',
        parentLevel : '父级',
        value :'值',
        parentPath :'父路径',
        description : '描述'
    },
    //系统日志
    system: {
        instructions : "系统日志列表，请点击文件名进行下载。",
        downloadPrompt : "确定要下载此系统日志吗？"
    },
    //用户管理
    userManager: {
        addVirtual: '添加虚拟用户',
        manager: '用户管理',
        userName: '真实姓名',
        userAccount: '账号',
        email: '邮箱',
        zoneCode: '区号',
        phone: '电话',
        enabled: '启用',
        userType: '用户类型',
        realUser: '真实用户',
        virtualUser: '虚拟用户',
        captcha: '验证码',
        validMessage: {
            userAccountOutLen: "长度必须小于60个字符",
            userAccountRegx: "账号必须以英文字母开头，并且只能包含英文字母和数字",
            phoneRegx: "请输入一个中国大陆的电话号码"
        },
        message: {
            noneAccount: "请填写账号",
            existAccount: "账号已经存在",
            existPhone: "该手机号已经存在",
            illegePhone: "手机号不合法",
            resetPwd: "密码重置成功！您的新密码为",
            captcha_1: "验证码错误",
            captcha_2: "请刷新验证码"
        },
        resetPwd: '重置密码',
        regist: '注册用户',
        downTemplate: '下载模版',
        oldPassword: '当前密码',
        newPassword: '新密码',
        confirmPassword: '确认密码',
        userNameRequired: '请输入真实姓名',
        phoneRequired: '请输入手机号',
        emailRequired: '请输入电子邮箱',
        passwordRequired: '请输入密码',
        newPasswordRequired: '请输入新密码',
        passwordReconfirm: '请再次确认密码',
        captchaRequired: '请输入图形验证码',
        authCaptchaRequired: '请输入短信验证码',
        getCaptcha: '获取验证码',
        resetTokenTips: '此用户未生成过令牌，如需要使用令牌，请先重置令牌。',
        resetTokenConfirmTitle: '确定要重置令牌吗？',
        resetTokenConfirm: '如果之前已生成令牌，重置后，之前的令牌将失效。',
    },
    //权限
    permission: {
        resetToken: '重置令牌',
        validToken: '验证令牌',
        tokenExpire: '令牌有效期至：',
        permissionManager: '权限管理',
        viewToken: '查看令牌',
        allotRole: '分配角色',
        allotDataRange: '数据范围',
        validMessage: {
            dateNull: "有效期不能为空",
            noneTenant: "请先选择一个租户",
        },
        list: '权限列表',
        havePermission: '拥有权限',
        grantPermission: '分配权限',
        syncPermission: '同步权限',
        delUnActPermission: '删除无效权限'
    },
    //角色管理
    roleManager: {
        manager: '角色管理',
        name: '角色名',
        desc: '描述',
        addRole: '添加角色'
    },
    //租户管理
    tenant: {
        manager: '租户管理',
        tenantName: '租户名称',
        productKey: 'PK码',
        tenantAccount: '租户账号',
        userAccount: "管理账号",
        moduleTemplate: "服务模版",
        addAccount: '添加账号',
        addTenant: '添加租户',
        grantManager: '授权管理',
        allotUser: '添加用户',
        setting: '基本设置',
        module: '模块',
        selectModule: '分配模块',
        message: {
            existUser: "账号已经存在",
            notNull:"租户名称不能为空",
            openSuccess: "开通模块成功",
            openPartSuccess: "开通部分模块成功",
            openFail: "开通模块失败",
            closeSuccess: "关闭模块成功",
            closePartSuccess: "关闭模块部分成功",
            closeFail: "关闭模块失败"
        }
    },
    //模块模版
    template: {
        templateTabName: "套餐管理",
        addTemplate: "创建套餐",
        templateName: "套餐名字",
        totalPrice: "总价",
        comment: "说明",
        type1: "默认套餐",
        type2: "定制套餐"
    },
    //模块
    module: {
        freeModule: "免费模块",
        riseModule: "增值模块",
        moduleStatus1: "开通中",
        moduleStatus2: "已开通",
        moduleStatus3: "开通失败",
        moduleStatus5: "关闭中",
        moduleStatus6: "已关闭",
        moduleStatus7: "关闭失败",
        price: "单价",
        pricing: "定价",
        unitPcs: "期数",
        unPricing: "未定价",
        freeTips: "不限时长",
        durationTips: "请设置使用时长",
        duration: "使用时长",
        duration1: "年",
        duration2: "个月",
        duration3: "周",
        unitPrice: "周期",
        unitPrice1: "每年",
        unitPrice2: "每月",
        unitPrice3: "每周",
        expireDate: "到期日",
        moduleName: "模块名",
        comment: "说明",
        renewal: "续费",
        openTips1: "此模块为增值模块，需要付费使用。",
        openTips2: "请填写需要开通的服务周期后提交。",
        openTips3: "此模块为免费模块，点击提交即可开通使用。",
        openTips4: "您将购买付费模块，请填写需要开通的服务周期后提交订单，支付订单后系统将在1个小时内为您开通。",
        openTips5: "我们将在开通后的第二天0点整开始计费，感谢您的使用！",
        openTips6: "您开通的模块为免费模块，点击提交即可开通使用，感谢您的使用！",
        open: "开通",
        notOpen: "未开通",
        close: "关闭",
        perpetual: "永久",
        choice: "组合模块",
        totalPrice: "总价",
        message: {
            closeConfirm1: "确认关闭此模块吗？",
            closeConfirm2: "请慎重执行此操作！关闭后将无法继续使用该模块，相应的数据也将清除，并且无法恢复！",
            unsupport: "功能暂未开放，请耐心等待"
        }
    },
    //数据范围管理
    program: {
        manager: '数据范围管理',
        addProgram: '添加数据范围',
        name: '数据范围名',
        dataDimension: '数据维度',
        viewDimension: '查看维度列表'
    },
    //维度管理
    dimension: {
        code: '维度编码',
        name: '维度名称',
        url: '维度服务',
        syncDimension: '同步维度',
        type: '维度类型',
        general: '普通维度',
        personnel: '人员维度'
    },
    export: {
        totalCount: '导出总数'
    },
    import: {
        remark: '错误下载'
    },
    // 运维工具
    ops: {
        // 异步任务监控
        asyncTaskTrace: {
            taskUUID: '任务ID',
            brokerUrl: 'Broker地址',
            queueName: '队列名称',
            messageType: '消息类型',
            consumerType: '消费类型',
            taskStatus0: '创建中',
            taskStatus1: '待执行',
            taskStatus2: '创建失败',
            taskStatus3: '执行中',
            taskStatus4: '执行成功',
            taskStatus5: '执行失败',
            messageContent: '消息内容',
            showMsgContent: '查看消息内容',
            openTrace: '开启监控',
            closeTrace: '关闭监控',
            setOpenCloseConfirm: '确定要开启或关闭监控吗？'
        },
        redisManager: {
            redisList : "Redis列表",
            redisContent :"Redis内容",
            redisName: "Redis名称",
            redisNameColon: "Redis名称:",
            redisValue: "Redis值",
            redisValueColon: "Redis值:",
            key:"键",
            value: "值",
        },
        consulManager: {
            agentChecks: '代理信息',
            serviceName: '服务名称',
            serviceId: '服务ID',
            healthChecks: '健康检查',
            serviceTags: '服务标签',
            serviceList: '服务列表',
            nodeName: '节点名称',
            address: '地址',
            nodeChecks: '节点检查',
            serviceChecks: '服务检查',
            enableMaintenance: '设置为维护状态',
            cancelMaintenance: '取消维护状态',
            setMaintenanceConfirm: '确定切换服务的维护模式吗?',
            deregister: '注销此服务',
            deregisterConfirm1: '确定注销此服务吗?',
            deregisterConfirm2: '注销后，此服务将下线，只能重启服务实例才可恢复!',
        }
    },
    // 定时任务
    clocky: {
        addJob: '添加定时任务',
        jobName: '名称',
        jobType: '服务类型',
        jobShard: '任务类型',
        statefulFlag: '执行方式',
        groupName: '组',
        cron: 'Cron',
        jobContent: '内容',
        jobStatus0: '未启动',
        jobStatus1: '启动中',
        jobStatus2: '运行中',
        jobStatus3: '停止中',
        triggerOnce: '执行一次',
        batchTrigger: '批量执行',
        viewTrace: '查看执行记录',
        viewTraceTitle: '{jobName}的执行记录',
        statefulFlagY: '顺序执行',
        statefulFlagN: '并发执行',
        jobTypeREST: 'RESTful',
        jobTypeCLOUD: 'Cloud',
        jobTypeRReason: "外网服务",
        jobTypeCReason: "Ribbon内网服务",
        shardFlagY: '共享任务',
        shardFlagN: '独立任务',
        jobShardYReason: '按租户隔离执行',
        jobShardNReason: '独立执行一次',
        pauseConfirm: '确定要暂停{jobName}吗?',
        batchPauseConfirm: '确定要暂停选中的任务吗?',
        pauseSuccess: '任务已暂停',
        resumeConfirm: '确定要重启{jobName}吗?',
        batchResumeConfirm: '确定要重启选中的任务吗?',
        resumeSuccess: '任务已重启',
        triggerConfirm: '确定要执行一次{jobName}吗?',
        batchTriggerConfirm: '确定要执行选中的任务吗?',
        triggerSuccess: '任务已执行',
        deleteConfirm: '确定要删除{jobName}吗？',
        totalTime: '用时(毫秒)',
        returnValue: '返回值',
        jobTraceStatus0: '失败',
        jobTraceStatus1: '成功',
    },
    //通知
    notify:{
        manager :{
            info : "通知管理",
            send : "发送通知",
            add : "添加通知",
            edit : "编辑通知",
            copy: "复制通知",
            title : "标题",
            content : "内容",
            objectType : "通知类型",
            platformPrivateLetters : "平台私信",
            platformNotice : "平台公告",
            sysNotice : "系统公告",
            sysPrivateLetters : "系统私信",
            channel : "通知渠道",
            SMS : "短信",
            ifRecord : "是否记录",
            sender:"发送人",
            sendTime:"发送时间",
            sendRecord:"发送记录",
            receiver:"接收人",
            readStatus:"读取状态",
            unread:"未读",
            read:"已读",
            notifyTime:"通知时间",
            readTime:"读取时间",
            sms:"短信",
            sendConfirmPrompt:"确定发送吗？",
            findContent:"查看内容",
            templateMax:"模版过大",
        }
    },
    //标签
    tag:{
        create:"添加标签",
        tagName:"标签名称",
        tagType:"标签类型",
        timesCited:"引用次数",
        userName:"最后更新人",
        tagIsExist:"该类型标签名称已存在"
    },
    //告警
    alarm:{
        details:"告警明细",
        faultTable:"故障告警列表",
        runTable:"运行告警列表",
        alarmType:"告警类型",
        runningAlarm:"运行时告警",
        faultAlarm:"故障告警",
        fireAlarm:"火警告警",
        time:"告警时间",
        comment:"告警描述",
        faultConfirm:"故障确认",
        fireConfirm:"火警确认",
        misreportConfirm:"误报确认",
        equipmentIsolation:"设备隔离",
        confirmSuccess:"确认成功",
        tooHigh:"过高",
        tooLow:"过低",
        info:"告警",
        offline:"离线",
        fault:"故障",
        untreated:"未处理",
        handlerState:"处理状态",
        handlerTime:"处理时间",
        normalTime:"恢复时间",
        trend:"告警趋势",
        total:"总数",
        statistics:"告警统计",
        statisticsNum:"统计数量",
        strategy:"告警策略",
        sourceCode:"点位源标识",
        confirm:"确认",
        alarmConfirm :"告警确认",
        promptAlarm:"提示告警",
        commonlyAlarm:"一般告警",
        seriousAlarm:"严重告警",
        normal:"正常",
        alarmNotify:",发生一条严重告警,告警状态:",
        recoveryNotify:",严重告警已恢复,当前状态:",
        comfirmMsg:"确定要人工处理此告警吗?",
        isolateMsg:"确定要将设备隔离吗?",
        cancelIsolateMsg:"确定取消隔离吗?",
        isolateTime:"隔离时长",
        isolate:"隔离",
        cancelIsolate:"取消隔离",
        batchIsolate:"批量隔离",
        batchCancel:"批量取消",
        isolated:"已隔离",
        notIsolated:"未隔离",
        isolateShortcut:"隔离1小时",
    },
    //地图
    map:{
        manager:"地图管理",
        updateMap:"更换地图",
        loading:"加载中",
        uploadFile1:"将文件拖到此处，或",
        uploadFile2:"点击上传",
        coordinate:"位置坐标",
        deleteMapConfirm:"确定移除该地图设备么？",
        selectPosition:"请选择位置!",
        runningState:"运行状态",
        running:"运行",
        stop:"停止",
        display:"地图展示",
        alarm:"报警",
        normal:"正常",
        auto:"自动",
        manual:"手动",
        fault:"故障",
        isOpenConfirm:"确定打开吗？",
        isCloseConfirm:"确定关闭吗？",
        position:"选择位置",
        mapView:"地图模式",
        listView:"列表模式",
        scaleUp:"放大一级",
        scaleDown:"缩小一级",
        addDeviceTips: "双击设备图标，即可添加设备",
        removeDeviceTips: "拖拽设备图标至地图左侧或上侧边缘，即可移除设备"
    },
    // 公用的内容
    commons: {
        upload: "上传",
        send: "发送",
        sendSuccess: "发送成功",
        sent: "已发送",
        waiting:"等待中",
        exporting:"导出中",
        cancelled:"已取消",
        reading:"读取中",
        importing:"导入中",
        search: '搜索',
        refresh: '刷新',
        copy: '复制',
        copyLink: '复制链接',
        dongjie: '冻结',
        jiedong: '解除冻结',
        searchPhrase: '请输入关键字搜索',
        searchAccount: '请输入姓名或账号',
        selectTenant:"请选择租户",
        selectPlease: '请选择...',
        index: '序号',
        actions: '操作',
        multipleSelectionTwo : '请至少选择两项',
        multipleSelectionOne : '请至少选择一项',
        clear: "清除",
        close: "关闭",
        clearAll: "清除所有",
        more: "查看更多",
        print: "打印",
        add: '添加',
        edit: '编辑',
        delete: '删除',
        batchDelete: '批量删除',
        destroy: '彻底删除',
        batchDestroy: '批量彻底删除',
        restore: '还原',
        batchRestore: '批量还原',
        confirm: '确定',
        cancel: '取消',
        save: '保存',
        batchsave: '批量保存',
        warning: '警告',
        prompt:'提示',
        competed: '完成',
        // 范围分隔
        rangeSeparator: '至',
        // 开始日期
        startDate: '开始日期',
        // 结束日期
        endDate: '结束日期',
        startTime: '开始时间',
        endTime: '结束时间',
        completeDate: '完成日期',
        creationTime: '创建时间',
        lastUpdateTime: '更新时间',
        creationDate: '创建日期',
        lastUpdateDate: '更新日期',
        day: '天',
        calendarDay:"日",
        // 最近一天
        lastDay: '最近一天',
        // 最近一周
        lastWeek: '最近一周',
        // 最近一个月
        lastMonth: '最近一个月',
        fullChoice: '全选',
        unFullChoice: '取消全选',
        dragSort: '拖拽排序',
        status: '状态',
        active: '有效',
        unActive: '失效',
        noRecords: "没有数据",
        empty : '无',
        export: '导出',
        import: '导入',
        importTemplate: '导入模版',
        chooseFile: '选取文件',
        uploadToBg: '上传到服务器',
        uploadFile: '上传文件',
        fileName: '文件名',
        type: '类型',
        tenant: '租户',
        appName: '所属应用',
        profileName: '运行环境',
        errorMsg: '异常信息',
        info: '消息',
        play: '播放',
        pause: '暂停',
        batchPause: '批量暂停',
        resume: '恢复',
        batchResume: '批量恢复',
        importInfo:{
            success : '导入成功',
            error : '导入失败'
        },
        errMsg: '错误信息',
        exportInfo:{
            success : '导出成功',
            error : '导出失败',
            process: '正在导出中...'
        },
        inA: '换一张',
        nextStep: '下一步',
        yes: '是',
        no: '否',
        notDeleteParent :"有子节点，不可删除",
        daily:"每日",
        weekly:"每周",
        monthly:"每月",
        yearly:"每年",
        quarterly:"每季",
        halfYear:"半年",
        each:"每次",
        minute:"分钟",
        period:"时间段",
        overView:"总览",
        details:"详情",
        actualStartTime:"实际开始时间",
        actualEndTime:"实际结束时间",
        costTime:"耗时",
        enable:"启用",
        selectDate:"选择日期",
        template:"模版",
        monday:"周一",
        tuesday:"周二",
        wednesday:"周三",
        thursday:"周四",
        friday:"周五",
        saturday:"周六",
        sunday:"周日",
        preview:"预览",
        defaultSelect:"默认选中",
        remark:"备注",
        notifyList:"消息列表",
        recycleBin:"回收站",
        qrCode:"二维码",
        min30:"30分钟",
        min60:"1小时",
        min120:"2小时",
        min180:"3小时",
        min360:"6小时",
        min720:"12小时",
        min1440:"24小时",
        viewDetails:"查看详情",
        clickToDownload:"点击下载",
        pleaseInput : '请输入...',
        hour720:"1个月(30天)",
        hour2160:"3个月(90天)",
        hour4320:"6个月(180天)",
        hour8760:"1年(365天)",
        hour26280:"3年(1095天)",
        hour43800:"5年(1825天)",
        noData:"暂无数据",
        location:"所在位置",
        submit:"提交",
        select:"选择",
        free:"免费",
        displayLayout :'显示布局',
        displayLayout_1 :'左侧显示菜单',
        displayLayout_2 :'顶部显示一级菜单',
        displayLayout_3 :'顶部显示所有菜单',
        one_level :"一级",
        two_level :"二级",
        three_level :"三级",
        four_level :"高能耗淘汰"
    },
    // 提示信息
    message: {
        // 切换语言成功
        switchLangSuccess: '切换语言成功',
        // 切换布局大小成功
        switchSizeSuccess: '切换布局大小成功',
        saveSuccess: '保存成功',
        deleteSuccess: '删除成功',
        openSuccess:'开启成功',
        suspendSuccess:'暂停成功',
        deleteConfirm: '确定要删除吗？',
        deleteAllConfirm: '确定要删除所有吗？',
        destroyConfirm: '确定要彻底删除吗？删除后无法恢复!',
        destroyAllConfirm: '确定要彻底删除所有吗？删除后无法恢复!',
        openConfirm:'确认开启吗？',
        editConfirm:"确定修改吗？",
        suspendConfirm:'确认暂停吗',
        resetConfirm: '确定要重置吗？',
        validSuccess: '验证成功',
        validFail: '验证失败',
        unfastenConfirm: '请确认对该账号执行解封？',
        sealConfirm: '确认封禁该账号吗？',
        operationSuccess: '操作成功',
        copySuccess: '已复制到剪贴板中',
        operationFailed: '操作失败',
        uploadSuccess: '上传成功',
        uploadFail: '上传失败',
        updateSuccess: '修改成功',
        updateFail: '修改失败',
        unknowException: '未知异常',
        errorPageTip: '抱歉，您访问的页面偷偷溜走了~~',
        invalidCaptcha: '请输入有效的验证码',
        commaTips: '不可以输入逗号!'
    },
    // 校验信息
    validate: {
        required: '此项必填',
        incorrectUrl: '不正确的URL',
        invalidEmail: '无效的邮箱'
    },
    facilityHome:{
        deviceTotal: "设备总数/台",
        orderCompleteNumber:"工单完成数/条",
        inspectionCompleteNumber:"巡检完成数/条",
        maintenanceCompleteNumber:"维保完成数/条",
        maintenanceLowerHairNumber:"维保下发数/条",
        jobCompleteRate:"任务完成率统计",
        orderCompleteTrend:"工单填报/完成数趋势",
        orderCompleteRank:"工单完成量排行",
        deviceTypeOrder:"设备类型工单统计",
        imStatistics:"巡检/维保完成数统计",
        fillNumber:"填报数",
        completeNumber:"完成数",
        order: "工单",
        inspection: "巡检",
        maintenance: "维保",
        number:"数量",
        actualCompleteNumber:"实际完成数",
        shouldFinishNumber:"未完成数",
        item: "条",
    },
    base:{
        category :{
            addRoot : "添加根类型",
            systemCategory : "系统分类",
            parentCategory : "上一级分类",
            code : "编码",
            workTime: "维修工时",
            workingTime: "运行时长",
         
            desc : "描述",
            system : "所属系统",
        },
        device :{
            level:"设备级别",
            advanced:"高级查找",
            number:"设备编号",
            select:"选择设备",
            name : "设备名称",
            position : "设备位置",
            dutyDept : "责任部门",
            factoryCode : "设备编号",
            principal: "负责人",
            type : "设备类型",
            power: "功率",
            label : "设备标签",
            deviceEui: "设备EUI",
            protocol: "协议模式",
            add: "添加设备",
            edit:"编辑设备",
            copy:"复制设备",
            deviceManager:"设备管理",
            monitorManager:"监控点管理",
            monitor:"监控点",
            monitorPath:"控制路径",
            historyTable:"历史表名",
            startIcon:"运行图标",
            stopIcon:"停止图标",
            addMonitor:"添加监控点",
            editMonitor:"编辑监控点",
            addIcon:"添加图标",
            editIcon:"编辑图标",
            cameraNo: "摄像编号",
            fetchUrl: "视频地址",
            userName: "用户名",
            password: "访问密码",
            proxyIP: "代理IP",
            proxyPort: "代理端口",
            deviceIP: "设备IP",
            devicePort: "PTZ端口",
            channelNum: "通道号",
            editCamera: "编辑视频",
            addCamera: "新增视频",
            message: {
                unOpenIOT: "您还没有开通IOT模块，请先开通后再配置监控点"
            }
        },
        monitor: {
            monitorPath:"点位路径",
            name:"监控点名",
            historyTable:"历史表名",
            controlSource:"控制源",
            alarmLevel:"告警级别",
            prompt:"提示",
            commonly:"一般",
            serious:"严重",
            monitorType:"点位类型",
            alarmFlag: "是否告警",
            autoOrder: "生成工单",
            industryType: "工业类型",
            alarmVoteValue: "告警值",
            lowValue: "过低临界",
            heightValue: "过高临界",
            alarmVoteDelay: "告警延迟",
            toleranceValue: "告警容差",
            isShow:"地图标记",
            desc:"备注",
            telecommand: "遥信",
            telemetering: "遥测",
            pleaseSelect:"请选择点位！",
            validMessage: {
                number:"请输入数字！",
                decimal:"请输入数字或小数！"
            }
        },
        source:{
            name:"源名称",
            userAccount:"源认证用户",
            userToken:"源认证密码",
            type:"源类型",
        },
        position:{
            name : "位置",
            manager :"位置管理",
            subPosition:"上一级位置",
            code:"位置编码",
            label:"位置标签",
            desc:"描述",
            devicePosition:"设备位置",
            project:"所属项目",
            selectProject:"选择项目",
            prompt:"请选择或添加一个位置",
        },
        project : {
            name : "项目",
            code:"编码",
            label:"项目标签",
            desc:"描述",
            list:"项目列表",
            add: "添加项目",
            edit:"编辑项目",
            city:"所在城市",
            address:"详细地址",
            floorSpace:"占地面积(m²)",
            location:"经纬度",
            pleaseSelectCity:"请选择城市!",
            locationNotExist:"经纬度不存在，请设置经纬度!",
        },
        employee :{
            user : "账号",
            userName: "姓名",
            phone: "手机",
            email:"邮箱",
            organiza:"组织",
            add:"添加人员",
            edit:"编辑人员",
            prompt:"账号已绑定组织"
        },
        company:{
            name :"公司",
            companyName:"公司名称",
            companyCode:"公司编码",
            companyEmployee:"公司人员",
            organiza:"组织结构",
            create:"添加公司",
            edit:"编辑公司",
            delete:"删除公司",
            details:"公司详情",
            area : "区域",
            prompt:"请选择公司或部门",
            label : "公司标签",
        },
        dept:{
            name:"部门",
            subDept:"下级部门",
            supDept:"上一级部门",
            subText:"当前部门不包含下级部门，可点击",
            createSon:"添加子部门",
            deptName:"部门名称",
            deptCode:"部门编码",
            create:"添加部门",
            edit:"编辑部门",
            delete:"删除部门",
            details:"部门详情",
            deptEmployee:"部门人员",
            notSupDept:"无上级部门",
            responsibleDept:"责任部门",
            responsiblePerson:"责任人员",
            handlePerson:"处理人员",
            dutyName:"岗位"
        },
        materiel:{
            list:"物料列表",
            materielName:"物料名称",
            name :"物料",
            edit:"编辑物料",
            create:"添加物料",
            code:"编码",
            type:"物料分类",
            mode:"规格型号",
            model:"型号",
            specification:"规格",
            unit:"单位",
            desc:"描述",
            collarDetails:"工单",
            label:"物料标签",
            category:{
                edit:"编辑物料分类",
                create:"添加物料分类",
                label:"分类标签"
            }
        },
    },
    maintenance:{
        template:{
            name:"维保模版",
            resultManager:"维保结果管理",
            itemNamePrompt:"维保项是否使用模版名称？",
        },
        code:"维保编码",
        list:"维保列表",
        generate:"生成维保",
        dynamic:"维保动态",
        details:"维保详情",
        company:"维保公司",
        self:"自维",
        external:"外维",
        contact:"联系人",
        name:"维保名称",
        planName:"维保计划",
        cycle:"维保周期",
        type:"维保类型",
        status:"维保状态",
        claim:"维保要求",
        position:"维保位置",
        ifScan:"是否扫码",
        addItem:"新建维保项",
        addDevice:"新建维保设备",
        editItem:"编辑维保项",
        editDevice:"编辑维保设备",
        result:"维保结果",
        device:"维保设备",
        item:"维保项",
        ifFailure:"是否失效",
        checkDuty:"核查岗位",
        serviceTerm:"服务期限",
        waitSuperviseCheck:"待督办审核",
        waitCheckDuty:"待核查审核",
        timePrompt:"开始时间:",
    },
    inspection:{
        plan :{
            add:"新建计划",
            edit:"编辑计划",
            name:"计划名称",
            cycle:"计划周期",
            executeDept:"责任部门",
            executeDuty:"执行岗位",
            superviseDuty:"督办岗位",
            executePerson:"执行人员",
            executePosition:"执行位置",
            jobCycle:"任务周期",
            ifEnable:"是否启用",
            list:"计划清单",
            advanceNotify:"提前通知",
            effectiveTime:"生效时间",
            invalidTime:"失效时间",
            day:"日",
            crossDay:"跨天"
        },
        template:{
            templateName:"模版名称",
            name:"巡检模版",
            manager:"模版管理",
            pleaseInputName:"请输入模版名称",
            pleaseSelectLib:"请选择模版库",
            editLib:"编辑模版库",
            add:"新建模版",
            edit:"编辑模版",
            notRemark:"无备注",
            systemLib:"系统模版库",
            lib:"模版库",
            libManager:"模版库管理",
            remark:"模版备注",
            isNotes:"是否备注",
            checkResult:"检查结果",
            checkItem:"检查项",
            checkContent:"检查内容",
            scoreContent:"评分内容",
            scoreStandard:"评分标准",
            maxScore:"最高分",
            copyContent:"抄录内容",
            scoreItem:"评分项",
            editItem:"编辑选项",
            copyItem:"抄录项",
            resultItem:"结果项",
            resultManager:"巡检结果管理",
            recodeResult:"记录结果",
            qualified:"合格",
            failed:"不合格",
            ifCopyPrompt:"确定复制模版吗？",
            notNull:"模版名称不能为空",
            containPrompt:"模板库内包含有模板！",
            itemNamePrompt:"巡检项是否使用模版名称？",
        },
        code:"巡检编码",
        list:"巡检列表",
        generate:"生成巡检",
        dynamic:"巡检动态",
        details:"巡检详情",
        name:"巡检名称",
        planName:"巡检计划",
        cycle:"巡检周期",
        status:"巡检状态",
        claim:"巡检要求",
        position:"巡检位置",
        ifScan:"是否扫码",
        addItem:"新建巡检项",
        addDevice:"新建巡检设备",
        editItem:"编辑巡检项",
        editDevice:"编辑巡检设备",
        result:"巡检结果",
        device:"巡检设备",
        item:"巡检项",
        ifPhoto:"是否拍照",
        leastOne:"至少保留一个",
        ifEnablePrompt:"确定启用计划么？",
        ifStopPrompt:"确定暂停计划么？",
        invalidTimePrompt:"生效时间不能大于失效时间!",
        unGreatDate:"不能大于结束时间:",
        monthCyclePrompt:"每月周期时间，开始时间:",
        weekCyclePrompt:"每周周期时间，开始时间:",
        dayCyclePrompt:"每日周期时间，在非跨天情况下，开始时间:",
        onceCyclePrompt:"每次周期时间，开始时间:"
    },
    order:{
        orderCode:"工单编码",
        other:"其他",
        materielDetail:"物料领用明细",
        workTimeConfigure:"工时设置",
        configure:"工单设置",
        makeMe:"自己做单",
        uploadLimit:"当前限制最多上传 3 个文件！",
        submitSuccess:"工单提交成功",
        cancelPrompt:"工单还未提交，确认关闭？",
        fill:"填报工单",
        place: "报单",
        list:"工单列表",
        details:"工单详情",
        completeDetail:"完成详情",
        dynamic:"工单动态",
        approve:"报单审核",
        waitReceive:"待领取",
        waitExecute:"待执行",
        executing:"执行中",
        completed:"已完成",
        completedWaitCheck:"执行完成待审核",
        declareCheckFailure:"报单审核失败",
        completeCheckFailure:"完成审核不通过",
        generateTime:"生成时间",
        declareTime:"报单时间",
        declareDept:"报单部门",
        declarePeople:"报单人员",
        level:"工单级别",
        status:"工单状态",
        faultDesc:"问题描述",
        faultPhoto:"故障照片",
        faultReason:"故障原因",
        serviceDept:"责任部门",
        servicePeople:"维修人员",
        serviceMethod:"维修方法",
        completedTime:"要求完成时间",
        submitTime:"完成提交时间",
        completedPhoto:"完成照片",
        qualityLevel:"品质级别",
        questionDesc:"问题描述",
        livePhoto:"现场照片",
        qualityType:"品质类型",
        advertising:"广告宣传",
        clearService:"清洁服务",
        buildDecoration:"土建/装饰",
        beautyChemical:"美陈美化",
        device:"设备设施",
        operationEnvironment:"运营环境",
        merchantService:"商户品质/服务",
        completedHappening:"完成情况",
        assistDept:"协助部门",
        assistPerson:"协助人员",
        workMatters:"工作事项",
        assistMatters:"协助事项",
        safetyLevel:"安全级别",
        dangerLevel:"隐患级别",
        safetyQuestion:"安全问题",
        safetyType:"安全类型",
        performanceManager:"履职管理",
        merchantManager:"商户管理",
        publicSafety:"公共安全",
        fireSafety:"消防安全",
        quality:"环境品质",
        orderType:"工单类型",
        constructSafety:"施工安全",
        appDept:"申请部门",
        appPerson:"申请人员",
        appTime:"申请时间",
        auditDept:"审核部门",
        auditPerson:"审核人员",
        auditTime:"审核时间",
        transfer:"转派",
        assist:"协助",
        delayed:"延时",
        materiel:"物料",
        complete:"完成",
        config:{
            declareIfReview:"报单是否审核",
            declareSuccessDesc:"(说明：如果关闭，报单成功后，不需要审核，直接派送)",
            orderSuccessReview:"工单完成审核",
            orderReportReview:"工单报单审核",
            executeDeptSupervisor:"责任部门主管",
            declarePerson:"报单人",
            designationPerson:"指定人",
            designationDept:"指定部门主管",
            deviceOrder:"设备设施类工单",
            fireSafetyOrder:"消防安全类工单",
            qualityOrder:"环境品质类工单",
            orderExecuteHour:"工单执行标准工时",
            workConnectOrder:"工作联络工单",
            orderExecuteDept:"工单责任部门",
            orderAssistDept:"工单协助部门",
            saveConfig:"保存设置",
            ordinary:"普通",
            urgent:"紧急",
            alarm:"告警",
            defDept:"默认责任部门",
            generalSafety:"一般安全隐患",
            largerSafety:"较大安全隐患",
            majorSafety:"重大安全隐患",
            observedItem:"观察项",
            generalFailed:"一般不合格",
            majorFailed:"严重不合格",
            dangerLevelDesc:"(说明：按隐患级别)",
            orderLevelDesc:"(说明：按工单级别)",
            waitReceiveConfig1:"待领取状态下的工单如果未被领取，每",
            waitReceiveConfig2:"分钟视为一次超时。",
            waitExecuteConfig1:"待执行状态的工单超过工时",
            waitExecuteConfig2:"分钟，还未开始执行视为一次超时，之后每过",
            waitExecuteConfig3:"分钟视为一次超时。",
            executingConfig1:"执行中的工单截止要求完成时间还未提交视为一次超时，之后每过",
            executingConfig2:"分钟视为一次超时。",
            overtimeConfig1:"第",
            overtimeConfig2:"次超时，上报岗位负责人。",
            overtimeConfig3:"次超时，上报部门负责人。",
            overtimeConfig4:"次超时，上报上级部门负责人，最多越",
            overtimeConfig5:"级上报。",
            addDeviceBySelf:"执行人添加设备",
            configTips:"(说明：如果开启，在工单执行时，执行人员在执行工单找不到相关设备时，可以自行添加设备)",
            timeoutAudit1:"超过",
            timeoutAudit2:"小时，自动审核",
            autoAudit:"自动审核",
            reportAutoAudit:"报单自动审核",
            completeAutoAudit:"完成自动审核",
            receiveTopLimit:"抢单上限",
            receiveTopLimitTips:"(说明：超过这个数量，用户将不能再领取新的工单)",
            pleaseSelectProject:"请选择项目",
            personIsNullTip:"指定人不能为空!",
            deptIsNullTip:"指定部门主管不能为空!",
            completeIfReview:"完成是否审核",
            completeIfReviewTip:"(说明：如果关闭，执行完成后，不需要审核，直接完成)",
            materielIfReview:"物料是否审核",
            materielIfReviewTip:"(说明：如果关闭，物料申请后，不需要审核，直接领用)",
            orderMaterielAudit:"工单物料审核",
            delayedIfReview:"延时是否审核",
            delayedIfReviewTip:"(说明：如果关闭，延时申请后，不需要审核，直接延时)",
            orderDelayedAudit:"工单延时审核",
            assistIfReview:"协助是否审核",
            assistIfReviewTip:"(说明：如果关闭，协助申请后，不需要审核，直接派发)",
            orderAssistAudit:"工单协助审核",
            assistPersonAudit:"协助人审核",
            assistPersonDeptAudit:"协助人部门主管",
            assistPersonIfReview:"协助人是否审核",
            assistPersonIfReviewTip:"(说明：如果关闭，协助申请后，协助人不需要审核，直接派发)",
            transferIfReview:"转派是否审核",
            transferIfReviewTip:"(说明：如果关闭，转派申请后，不需要审核，直接转派)",
            orderTransferAudit:"工单转派审核",
            recipientAudit:"接收人审核",
            recipientDeptAudit:"接收人部门主管",
            recipientIfReview:"接收人是否审核",
            recipientIfReviewTip:"(说明：如果关闭，转派申请后，接收人不需要审核，直接转派)",
        },
        statistics:{
            orderStatistics:"工单统计",
            reportsNumber:"填报工单(个)",
            completeNumber:"已完成工单(个)",
            receiveOvertimeNumber:"超时领取工单工单(个)",
            implementOvertimeNumber:"超时执行工单(个)",
            completeOvertimeNumber:"超时完成工单(个)",
            completeOrderTrend:"完成工单趋势",
            completeOrderStatistics:"完成工单统计",
            reportOrderTrend:"填报工单趋势",
            reportOrderStatistics:"填报工单统计"
        }
    },
    pump: {
        mqtt: {
            createServer: "添加服务",
            clientId: "客户端ID",
            status: "服务状态",
            serverAddress: "服务地址",
            userName: "用户名",
            password: "密码",
            topicSpec: "订阅标志",
            connectTimeout: "超时时间(s)",
            keepInterval: "心跳(s)",
            recoveryInterval: "恢复(s)",
            feedHandle: "解析实例",
            start: "启动",
            stop: "停止",
            connected: "已连接",
            unconnected: "未连接",
            connecting: "连接中",
            stoping: "停止中",
            connectfail: "连接失败",
        }
    },
    //后台服务模块
    iori: {
        resource: {
            common: "平台*通用",
            baseSetting: "平台*基础设置",
            userSetting: "平台*用户设置",
            ops: "平台*运维工具",
            tenantBaseSetting: "租户*基础设置",
            tenantUserSetting: "租户*用户设置",
            tenantBasicManagement:"租户*基础管理",
            tenantOrderManagement:"租户*工单管理",
            tenantInspectionManagement:"租户*巡检管理",
            tenantMaintenanceManagement:"租户*维保管理",
            iot: {
                tenantDataCenter: "租户*数据中心",
            },
            tenantIoTManagement:"租户*IoT管理"
        },
        operation: {
            findSitemap: "查询菜单",
            managePermission: "权限管理",
            searchDimension: "查询维度",
            searchOrg: "组织结构查询",
            manageOrg: "组织结构管理",
            manageTenant: "租户管理",
            manageUser: "用户管理",
            tenantSetting: "租户设置",
            manageSitemap: "菜单管理",
            manageLookup: "数据字典管理",
            manageRegistry: "注册表管理",
            manageTag: "标签管理",
            manageNotify: "通知管理",
            manageLogger: "日志管理",
            manageJob: "定时任务管理",
            findLogger: "日志管理",
            manageAsyncTask: "异步任务管理",
            manageRedis: "缓存管理",
            manageConsul: "微服务管理",

            searchDevice: "设备查询",
            manageDevice: "设备管理",
            searchCategory:"系统分类查询",
            manageCategory:"系统分类管理",
            searchMonitor:"监控点查询",
            manageMonitor:"设备绑点",
            searchDeviceMap:"地图查询",
            manageDeviceMap:"地图管理",
            searchMaterielCategory:"物料分类查询",
            manageMaterielCategory:"物料分类管理",
            searchMateriel:"物料查询",
            manageMateriel:"物料管理",
            searchPosition:"位置查询",
            managePosition:"位置管理",
            searchProject:"项目查询",
            manageProject:"项目管理",
            searchControlSource:"控制源查询",
            manageControlSource:"控制源管理",
            setPoint:"点位控制",

            orderSetting:"工单设置",
            orderSearch:"工单查询",

            inspectionSearch:"巡检查询",
            inspectionManage:"巡检管理",
            maintenanceSearch:"维保查询",
            maintenanceManage:"维保管理",

            iot:{
                nanhai :{
                    findPoint:"点位查询",
                    findAlarm:"告警查询",
                }
            }
        },
        sso: {
            operation: {
                login: "登录",
                register: "注册",
                forgetpwd: "忘记密码",
                searchSsoUser: "账号查询",
                manageSsoUser: "账号管理",
            }
        },
    },
    ginkgo:{
        ibms:{
            resource:{
                controlSourceService:"系统集成*控制源管理",
                deviceMapService:"系统集成*地图管理",
            },
            operation:{
                findControlSource:"查询控制源",
                deleteControlSource:"删除控制源",
                createControlSource:"添加控制源",
                updateControlSource:"编辑控制源",
                setPoint:"控制点位",

                createDeviceMap:"添加地图",
                updateDeviceMap:"更新地图",
                deleteDeviceMap:"删除地图",
                findDeviceMap:"查询地图",
            }
        },
        bas:{
            system: {
                existhead : "公司、部门、岗位中存在负责人",
            },
            resource : {
                monitorService:"基础管理*点位管理",
                deviceCategoryService : "基础管理*设备分类管理",
                deviceService : "基础管理*设备管理",
                deviceMonitorService: "基础管理*监控点管理",
                materielCategoryService:"基础管理*物料分类管理",
                materielService:"基础管理*物料管理",
                positionService:"基础管理*位置管理",
                projectService:"基础管理*项目管理",
            },
            operation:{
                findMonitor:"查询点位",
                updateMonitor:"编辑点位",
                createMonitor:"添加点位",
                deleteMonitor:"删除点位",

                findDeviceCategory :"查询设备分类",
                createDeviceCategor :"添加设备分类",
                deleteDeviceCategor :"删除设备分类",
                updateDeviceCategor :"编辑设备分类",

                findDevice : "查询设备",
                createDevice : "添加设备",
                deleteDevice: "删除设备",
                exportDevice: "导出设备",
                updateDevice: "编辑设备",

                findDeviceMonitor : "查询监控点",
                createDeviceMonitor: "添加监控点",
                deleteDeviceMonitor: "删除监控点",
                updateDeviceMonitor: "编辑监控点",

                findMaterielCategory:"查询物料分类",
                createMaterielCategory:"添加物料分类",
                deleteMaterielCategory:"删除物料分类",
                updateMaterielCategory:"编辑物料分类",

                findMateriel: "查询物料",
                createMateriel: "添加物料",
                deleteMateriel: "删除物料",
                updateMateriel: "编辑物料",

                findPosition: "查询位置",
                createPosition: "添加位置",
                deletePosition: "删除位置",
                updatePosition: "编辑位置",
                exportPosition: "导出位置",

                findProject: "查询项目",
                createProject: "添加项目",
                deleteProject: "删除项目",
                updateProject: "编辑项目",
            }
        },
        order :{
            resource :{
                orderService : "设备设施*工单管理"
            },
            operation :{
                executeorder :"执行工单",
                findorderlist :"查询工单",
                configure : "工单设置",
                createorder: "添加工单"
            }
        },
        inspection:{
            resource:{
                jobService : "设备设施*巡检任务",
                planService : "设备设施*巡检计划",
                templateService: "设备设施*巡检模版"
            },
            operation:{
                findInspectionJob: "查询巡检任务",
                implementInspectionJob: "执行巡检任务",
                createInspectionJob: "添加巡检任务",
                export: "巡检导出",

                deleteInspectionPlan: "删除巡检计划",
                updateInspectionPlan: "编辑巡检计划",
                addInspectionPlan: "添加巡检计划",
                findInspectionPlan: "查询巡检计划",

                findInspectionTemplate : "查询巡检模版",
                addInspectionTemplate : "添加巡检模版",
                updateInspectionTemplate : "编辑巡检模板",
                deleteInspectionTemplate: "删除巡检模版",

            }
        },
        maintenance : {
            resource : {
                jobService : "设备设施*维保任务",
                planService : "设备设施*维保计划",
                templateService : "设备设施*维保模版"
            },
            operation: {
                findJob: "查询维保任务",
                implementJob :"执行维保任务",
                createJob : "添加维保任务",
                export : "维保导出",

                findPlan:"查询维保计划",
                addPlan: "添加维保计划",
                deletePlan: "删除维保计划",
                updatePlan: "编辑维保计划",

                findTemplate: "查询维保模版",
                addTemplate: "添加维保模版",
                deleteTemplate:"删除维保模版",
                updateTemplate:"编辑维保模版"
            }
        },
    },
    iot: {
        pump: {
            resource: {
                mqttServerService: "平台*MQTT监听配置",
                tenantIoTAlarm: "租户*告警管理"
            },
            operation: {
                findMqttServer: "查询监听",
                createMqttServer: "添加监听",
                delMqttServer: "删除监听",
                updateMqttServer: "更新监听",
                controlMqttServer:"MQTT服务配置",

                confirmAlarm:"确认告警"
            }
        },
        nanhai :{
            resource : {
                pointCacheService:"IOT管理*点位缓存",
                historyService:"IOT管理*历史数据",
                realtimeService:"IOT管理*实时数据",
            },
            operation: {
                findPointCache:"查询点位缓存",
                historyPoint:"历史点位",
                historyAlarm:"历史告警",

                pointInformation:"实时点位",
                alarmInformation:"实时告警"
            }
        }
    },
    input: {
        electric: {
            aircondition: {
                aircondition: "暖通空调",
                month: "月份",
                name: "设备名称",
                position: "设备位置",
                num: "读表数",
                projectchoose: "选择项目",
                positionchoose: "选择位置"
            }
            
        },
        price: {
            num: "编号",
            name: "价格名称",
            price: "单价"
        },
        performanc: {
            type: "类型",
            num: "时间",
            season: "季度",
            month: "月份",
            name: "目标名称",
            value: "目标值"
        },
        quota: {
           
            num: "时间",
            season: "季度",
            month: "月份",
            name: "定额名称",
            value: "定额"
        },
        performance: {
            num: "序号",
            name: "绩效标准名称",
            value: "标准值"
        },
        consumption: {
            num: "编号",
            name: "系数名称",
            value: "系数值",
            year: "年份",
            month: "月份",
            createtime: "创建时间",
        
            parametername: "能耗影响原因",
            parametervalue: "值",

            totalarea: "总建筑面积",
            airconditionarea: "空调用电建筑面积",
            hotarea: "采暖建筑面积",
            winterin: "冬季室内平均温度",
            winterout: "冬季室外平均温度",
            summerin: "夏季室内平均温度",
            summerout: "夏季室外平均温度",
            totalperson: "用能人数",
        },
        wuHaiHome: {
            itemOverview: "项目概况",
            itemTotal: "项目总数",
            areaTotal: "总建筑面积",
            deviceNum: "接入设备数量",
            accessData: "接入数据占位点",
            runManage: "运行管理",
            onlineDevice: "在线设备数",
            equipmentTotal: "设备总数",
            alarmNum: "待处理报警数",
            alarmTotal: "报警总数",
            assetManage: "资产管理",
            drain: "排水",
            illumination: "照明",
            power: "强弱电",
            warmRoad: "暖道",
            maintenanceManage: "运维管理",
            comeUp: "同比上浮",
            alarmManage: "报警管理",
            general: "一般",
            prompt: "提示",
            serious: "严重",
            energyManage: "能耗管理",
            firstQuarter: "第一季度",
            secondQuarter: "第二季度",
            thirdQuarter: "第三季度",
            fourthQuarter: "第四季度",
            waterYield: '水量',
            electric: '电量',
            airFlow: '气量'
        }

        
    }
}
